/**
 * Created by anatolij on 21.10.2026
 */

const RoyalLeagueRulesWindow = GuideWindow.extend({
    onWindowLoaded: function () {
        this._super({
            name: "RoyalLeagueRulesWindow",
            title: "RoyalLeagueRulesWindow.title",
            bundle: bundles.royal_league_rules_window
        });
    },

    listBundles: function () {
        return ["royal_league_rules_window"];
    }
});
